import { render, staticRenderFns } from "./detailsMessageParent.vue?vue&type=template&id=91f7401e&"
import script from "./detailsMessageParent.vue?vue&type=script&lang=js&"
export * from "./detailsMessageParent.vue?vue&type=script&lang=js&"
import style0 from "./detailsMessageParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports